import { PageSize } from "./../../types/schema";

export default [
  { label: "50", value: PageSize.Fifty },
  { label: "100", value: PageSize.Hundred },
  { label: "200", value: PageSize.TwoHundred },
  { label: "500", value: PageSize.FiveHundred },
];
